import {Role} from "@/_helpers/roles"
export default {
    items: [
        {
            name: "Каталог",
            url: "/tree",
            icon: "fa fa-circle",
        },
        {
            name: "verification",
            url: "/verification",
            icon: "fa fa-circle",
            role: Role.admin,
        },
        {
            name: "предложения",
            url: "/suggestions",
            icon: "fa fa-circle",
        },
        {
            name: "Мои действия",
            url: "/myverifications",
            icon: "fa fa-circle",
        },
        {
            name: "Отчёты",
            url: "/reports",
            icon: "fa fa-circle"
        },
        {
            name: "Пользователи",
            url: "/user",
            role: Role.admin,
            icon: "fa fa-circle"
        },
        {
            name: "Единицы измерения",
            url: "/unit",
            role: Role.admin,
            icon: "fa fa-circle"
        },
        {
            name: "Языки",
            url: "/language",
            role: Role.admin,
            icon: "fa fa-circle"
        },
        /* {
            name: "Все категории",
            url: "/category",
            icon: "fa fa-circle"
				} */
        {
            name: "Все Классы",
            url: "/products",
            role: Role.admin,
            icon: "fa fa-circle"
        },
        {
            name: "Переводы",
            url: "/translations",
            icon: "fa fa-circle"
        },
        {
            name: "Логи действий",
            url: "/logs",
            icon: "fa fa-circle"
        },
      {
        name: "Комбинация",
        url: "/combination-v2",
        icon: "fa fa-circle",
        role: Role.combination_user,
      },
    ]
};
